import {
  WIRCreateJourneyStepsKeys,
  WIRStageGate1SectionKey,
  WIRStageGate1Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

export const getWirStageGate1Sections = (wir: WIR | null) =>
  (wir &&
    Object.keys(WIRStageGate1Sections).map(item => ({
      label: WIRStageGate1Sections[item as WIRStageGate1SectionKey],
      value: item,
      phase: WIRCreateJourneyStepsKeys.STAGE_GATE_1,
    }))) ??
  [];
